<template>
  <filter-wrapper @submit="submit">
    <div class="filter__row">
      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('pbx.stat.common.filter.group_by.values.type') }}
        </label>
        <div class="filter__item__body">
          <select-type v-model="form.type" />
        </div>
      </div>

      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('pbx.stat.common.filter.group_by.values.destination') }}
        </label>
        <div class="filter__item__body">
          <select-destination v-model="form.destination" />
        </div>
      </div>

      <div class="filter__item filter__item--datepicker col-6">
        <label class="filter__item__title">
          {{ $t('shared.component.filter.period') }}
          <tooltip
            class="ml-1"
            placement="top"
            min-width="200"
            max-width="200"
            theme="light"
            :content="$t('pbx.stat.tooltips.period')"
          >
            <icon size="16" type="ios-help-circle-outline" />
          </tooltip>
        </label>
        <div class="filter__item__body">
          <date-range-picker v-model="form.date" />
        </div>
      </div>
    </div>
    <div class="filter__row">
      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('pbx.stat.table.field.src') }}
        </label>
        <div class="filter__item__body">
          <i-input v-model="form.src_number" type="number" :clearable="true" />
        </div>
      </div>
      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('pbx.stat.table.field.dst') }}
        </label>
        <div class="filter__item__body">
          <i-input v-model="form.dst_number" type="number" :clearable="true" />
        </div>
      </div>
      <div class="filter__item col-3">
        <label class="filter__item__title">{{ $t('pbx.stat.table.field.type_answer') }}</label>
        <div class="filter__item__body">
          <select-type-answer v-model="form.state" multiple />
        </div>
      </div>
      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('pbx.stat.table.field.sip_account') }}
        </label>
        <div class="filter__item__body">
          <i-input v-model="form.peer" :clearable="true" />
        </div>
      </div>
    </div>

    <div class="filter__row">
      <div class="filter__item filter__item--button ml-auto">
        <i-button html-type="submit" type="primary">
          {{ $t('shared.component.filter.show_result') }}
        </i-button>
      </div>
      <div v-if="is_record_allow" class="filter__item filter__item--button">
        <i-button type="primary" @click="createExport">
          {{ $t('shared.component.export_report.export_records') }}
        </i-button>
      </div>
    </div>
  </filter-wrapper>
</template>

<script>
  import FilterWrapper from '@shared/components/filter-base';
  import { mapActions, mapGetters } from 'vuex';
  import SelectType from '@pbx/components/stats/filters/select-type';
  import SelectTypeAnswer from '@pbx/components/stats/filters/select-type-answer';
  import SelectDestination from '@pbx/components/stats/filters/select-destination';
  import SelectContacts from './select-contact';
  import { initSearchStateByPeriod, parseSearchStateByPeriod } from '@shared/helpers/date_format';
  import { ExportModalService } from '@pbx/modals/ExportModalService';

  export default {
    components: {
      FilterWrapper,
      SelectType,
      SelectDestination,
      SelectTypeAnswer,
      SelectContacts
    },
    /**
     *
     * TODO :: initSearchStateByPeriod
     * Раньше везде было:
     *  - moment().subtract(1, 'w');
     *
     *  Но в данном случае падала ошибка и тут написали:
     *  - moment().subtract(6, 'd')
     *
     *  Если решат вернуть 1 week - то нужно проверить этот метод.
     */
    data: () => ({
      form: {
        date: initSearchStateByPeriod(),
        state: '',
        destination: '',
        type: '',
        src_number: null,
        dst_number: null,
        peer: ''
      }
    }),
    computed: {
      ...mapGetters('core/auth', ['user']),
      is_record_allow() {
        return this.user.pbx.record;
      }
    },
    mounted() {
      this.submit();
    },
    methods: {
      ...mapActions('pbx/stats/detailed/table', ['search']),
      createExport() {
        ExportModalService.create().on('success', () => this.getAsyncData());
      },
      submit() {
        const { start, end } = parseSearchStateByPeriod(this.form.date);
        const { type, destination, state, src_number, dst_number, peer } = this.form;
        const stateString = state.toString();

        const params = {
          date_from: start,
          date_to: end,
          destination,
          dst_number,
          src_number,
          state: stateString,
          type,
          peer
        };

        this.search(params);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .filter__item--button {
    padding-top: 25px;
    text-align: right;
    padding-right: 0;
  }
</style>
